import * as stylex from "@stylexjs/stylex";
import { forwardRef, type SelectHTMLAttributes } from "react";
import { controlStyles } from "./control-styles";
export interface SelectOption {
  label: string;
  value: string;
}
export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "className" | "style" | "size"> {
  options?: SelectOption[];
  size?: "sm" | "md";
  xstyle?: stylex.StyleXStyles;
}
const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select({
  options,
  size = "md",
  xstyle,
  children,
  ...props
}, ref) {
  return <select ref={ref} {...props} {...stylex.props(controlStyles.control, controlStyles.select, size === "sm" && controlStyles.sm, xstyle)}>
      {options ? options.map(option => <option key={option.value} value={option.value}>
              {option.label}
            </option>) : children}
    </select>;
});
export default Select;